// utils/formatModalDate.ts

import convertCSTToLocal from "./convertCSTToLocal";

/**
 * Formats a backend date string (CST) to "MM/DD/YYYY" in the user's local timezone.
 * If the input is not a valid date string, it returns the original input.
 *
 * @param {string} [dateString] - The date string to format.
 * @returns {string} - The formatted date string or the original string if invalid.
 */
function formatModalDate(dateString?: string): string {
	if (!dateString) return "";

	const localDate = convertCSTToLocal(dateString);

	if (!localDate.isValid()) return dateString;

	return localDate.format("MM/DD/YYYY");
}
export default formatModalDate;
